'use client';

import type { FC } from 'react';
import { Skeleton } from '../../components/ui';

export const ReferralItemSkeleton: FC = () => {
  return (
    <div className="flex items-center gap-3 ps-3 pe-[10px] min-h-[60px]">
      <Skeleton className="size-8 rounded-full shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col py-2">
        <Skeleton className="h-[18px] w-[120px] max-w-[60%]" />
      </div>
      <Skeleton className="h-[18px] w-16 shrink-0" />
    </div>
  );
};
